import React from 'react';

type PraivoxBrandingProps = {
  className?: string;
  prefix?: string;
};

const PraivoxBranding: React.FC<PraivoxBrandingProps> = ({ className = '', prefix = 'Powered by' }) => {
  return (
    <span className={className}>
      {prefix}{' '}
      <a
        href="https://praivox.com"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 underline-offset-2 hover:underline"
      >
        Praivox
      </a>
    </span>
  );
};

export default PraivoxBranding;
